import { useEffect, useState } from 'react';

function usePrefersReducedMotion() {
  const [reduceMotion, setReduceMotion] = useState(
    //prefers-reduced-motion => Grab the preferences value of reducing the animation  in OS.
    // It doesn't disable animations automatically, so the onus is on us—the developers—to take advantage of it. ;)
    () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');

    const handleMediaChange = () => {
      setReduceMotion(mediaQuery?.matches);
    };

    mediaQuery?.addListener(handleMediaChange);
    handleMediaChange();

    return () => {
      mediaQuery?.removeListener(handleMediaChange);
    };
  }, []);

  return reduceMotion;
}

export default usePrefersReducedMotion;
